import { IColumnTypes, IFilterType } from 'components/spreadsheet/types'
import { FilterTypesToDescription } from 'components/spreadsheet/constants/const'
import { ITableViewFilter } from 'types'

// Conditions that need no value: "is empty".
const NO_VALUE = new Set([
  IFilterType.is_null,
  IFilterType.is_not_null,
  IFilterType.is_valid,
  IFilterType.is_not_valid,
  IFilterType.all_values
])
// The conditions picked from a list; "is in" is typed, like "contains".
const LIST = new Set([IFilterType.one_of, IFilterType.not_one_of])
// The values a list names before it counts the rest.
const LISTED = 3

const valueText = (value: string) => {
  if (value === '') return 'Empty'
  if (value === '{{date.today}}') return 'today'
  return value
}

// A filter as words, as its pill reads in the Filter panel: "one of USA, UK and 2 more", "is not empty".
export const describeFilter = (filter: ITableViewFilter, kind: IColumnTypes): string => {
  const condition = FilterTypesToDescription[filter.filterType] ?? filter.filterType
  if (NO_VALUE.has(filter.filterType)) return condition
  if (kind === 'checkbox') return filter.value === 'true' ? 'is ticked' : 'is not ticked'
  if (LIST.has(filter.filterType)) {
    // A saved filter may come back without its list.
    const values = (filter.multipleValues ?? []).map(valueText)
    if (values.length === 0) return `${condition} (nothing picked)`
    const named = values.slice(0, LISTED).join(', ')
    return values.length > LISTED ? `${condition} ${named} and ${values.length - LISTED} more` : `${condition} ${named}`
  }
  return `${condition} ${valueText(filter.value)}`
}

// What a column's filters keep, for the tip on its header's filter icon.
export const describeColumnFilters = (filters: ITableViewFilter[], kind: IColumnTypes): string =>
  `Filtered: ${filters.map((filter) => describeFilter(filter, kind)).join('; ')}`
